import {initNews} from './initNews';

export const initChooserWithNews = () => {
	const chooserWithNews = document.querySelector( 'section.chooser-with-news' );

	if ( !chooserWithNews )
	{
		return;
	}

	initNews( chooserWithNews );
};